import { render } from "./mvt-nearbyvideo.vue?vue&type=template&id=7fdfde25"
import script from "./mvt-nearbyvideo.js?vue&type=script&lang=js"
export * from "./mvt-nearbyvideo.js?vue&type=script&lang=js"

import "./mvt-nearbyvideo.vue?vue&type=style&index=0&id=7fdfde25&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__